import {ChangeEvent, useCallback} from 'react';
import {Checkbox as BaseCheckbox, CheckboxProps} from '@esgi/ui-kit/control';
import {ElementStatus, useFormElementContext} from '@esgi/ui-kit/form';
import {useForwardRef} from '@esgi/ui-kit/utils';

type OverrideProps = Omit<CheckboxProps, 'checked' | 'onChange' | 'disabled'>

export function Checkbox(props: OverrideProps): JSX.Element {
	const {setRef, setValue, status, value} = useFormElementContext({boolean: true});
	const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setValue(e.target.checked), [setValue]);
	const ref = useForwardRef(setRef, props.innerRef);

	return <BaseCheckbox {...props}
	                     checked={value}
	                     onChange={onChange}
	                     innerRef={ref}
	                     aria-invalid={status === ElementStatus.invalid}
	                     disabled={status === ElementStatus.disabled}/>;
}
